const opDataList = [
  {
    year: 2020,
    list: [
      {
        month: 6,
        link: ''
      },
      {
        month: 5,
        link: ''
      },
      {
        month: 4,
        link: ''
      },
      {
        month: 3,
        link: ''
      },
      {
        month: 2,
        link: ''
      },
      {
        month: 1,
        link: ''
      }
    ]
  },
  {
    year: 2019,
    list: [
      {
        month: 12,
        link: ''
      },
      {
        month: 11,
        link: ''
      },
      {
        month: 10,
        link: ''
      },
      {
        month: 9,
        link: ''
      },
      {
        month: 8,
        link: ''
      },
      {
        month: 7,
        link: ''
      },
      {
        month: 6,
        link: ''
      },
      {
        month: 5,
        link: ''
      },
      {
        month: 4,
        link: ''
      },
      {
        month: 3,
        link: ''
      },
      {
        month: 2,
        link: ''
      },
      {
        month: 1,
        link: ''
      }
    ]
  },
  {
    year: 2018,
    list: [
      {
        month: 12,
        link: ''
      },
      {
        month: 11,
        link: ''
      },
      {
        month: 10,
        link: ''
      },
      {
        month: 9,
        link: ''
      },
      {
        month: 8,
        link: ''
      },
      {
        month: 7,
        link: ''
      },
      {
        month: 6,
        link: ''
      },
      {
        month: 5,
        link: ''
      },
      {
        month: 4,
        link: ''
      },
      {
        month: 3,
        link: ''
      },
      {
        month: 2,
        link: ''
      },
      {
        month: 1,
        link: ''
      }
    ]
  },
  {
    year: 2017,
    list: [
      {
        month: 12,
        link: ''
      },
      {
        month: 11,
        link: ''
      },
      {
        month: 10,
        link: ''
      },
      {
        month: 9,
        link: ''
      },
      {
        month: 8,
        link: ''
      },
      {
        month: 7,
        link: ''
      },
      {
        month: 6,
        link: ''
      },
      {
        month: 5,
        link: ''
      },
      {
        month: 4,
        link: ''
      },
      {
        month: 3,
        link: ''
      },
      {
        month: 2,
        link: ''
      },
      {
        month: 1,
        link: ''
      }
    ]
  },
  {
    year: 2016,
    list: [
      {
        month: 12,
        link: ''
      },
      {
        month: 11,
        link: ''
      },
      {
        month: 10,
        link: ''
      },
      {
        month: 9,
        link: ''
      },
      {
        month: 8,
        link: ''
      },
      {
        month: 7,
        link: ''
      },
      {
        month: 6,
        link: ''
      },
      {
        month: 5,
        link: ''
      },
      {
        month: 4,
        link: ''
      },
      {
        month: 3,
        link: ''
      },
      {
        month: 2,
        link: ''
      }
    ]
  }
];

export default opDataList;
